import React, { useEffect, useState } from "react";
import {
  Grid,
  Button,
  Card,
  CardContent,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import { history } from "../../lib";

import {
  adminActions,
  adminSelectors,
  useDispatch,
  useSelector,
} from "../../state";
import { useFormik } from "../../lib";

import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";

import { useStyles } from "./AddCoveragePage.styles";
import { useParams } from "react-router";

const initialValues = {
  id: -1,
  state_requirements: {},
  state: "",
};

const EditStateRequirementPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const params: { id: string } = useParams();
  const states: any[] = useSelector(adminSelectors.states);
  const [activeState, setActiveState] = useState(initialValues);

  const form = useFormik({
    enableReinitialize: true,
    initialValues: activeState,
    async onSubmit(values) {
      await dispatch(adminActions.updateState(params.id, values));
      history.push("/admin/states");
    },
  });

  useEffect(() => {
    dispatch(adminActions.setPageTitle("State Specific Options"));
  }, [dispatch]);

  useEffect(() => {
    if (!states.length) {
      dispatch(adminActions.getStates());
    } else {
      const match = states.find((r) => r.id === parseInt(params.id));
      if (match) {
        setActiveState({
          id: match.id,
          state_requirements: match.state_requirements,
          state: match.state,
        });
      }
    }
  }, [dispatch, states, params]);

  return (
    <Card variant="outlined" className={classes.formCard}>
      <CardContent className={classes.formWrap}>
        <form onSubmit={form.handleSubmit}>
          <Grid container>
            <Grid item xs={12} className={classes.formControl}>
              {activeState.state}
            </Grid>
            <Grid item xs={10} className={classes.formControl}>
              <Typography style={{ color: "#b4b4d4" }}>
                State Options
              </Typography>
              <Paper>
                <Box className={classes.jsonInput}>
                  <JSONInput
                    key={activeState.id}
                    id="state_requirements"
                    name="state_requirements"
                    label="State Requirements"
                    placeholder={form.values.state_requirements}
                    onChange={(e) => {
                      form.setFieldValue("state_requirements", e.jsObject);
                    }}
                    colors={{
                      default: "#484c4f",
                      background: "#eff1f6",
                      background_warning: "#FEECEB",
                      string: "#FA7921",
                      number: "#70CE35",
                      colon: "#49B8F7",
                      keys: "#1277ab",
                    }}
                    height={"100%"}
                    width={"100%"}
                    locale={locale}
                    error={
                      form.touched.state_requirements &&
                      Boolean(form.errors.state_requirements)
                    }
                    helperText={
                      form.touched.state_requirements &&
                      form.errors.state_requirements
                    }
                  ></JSONInput>
                </Box>
              </Paper>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end">
            <Grid item className={classes.formAction}>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={
                  !(form.values.state && form.values.state_requirements)
                }
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default EditStateRequirementPage;
